<div class="ad-step1">
    <div class="container">
        <div class="level-bar pt-5 pb-5">
            <div class="half-line level-bar-active"></div>
            <div class="level level-bar-active">1</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">2</div>
            <div class="full-line level-bar-active"></div>
            <div class="level level-bar-active">3</div>
            <div class="full-line"></div>
            <div class="level">4</div>
            <div class="full-line"></div>
            <div class="level">5</div>
            <div class="full-line"></div>
            <div class="level"><img src="assets/check-red.png" style="width: 26px; height: auto" alt=""></div>
            <div class="full-line"></div>
        </div>
        <div class="level-text">
            Step 3 of 5
        </div>
        <div class="page-contents">
            <div class="heading">
                <h1>Fill up the details of your property</h1>
                <p>5 steps to post ad of your property.</p>
            </div>
            <div class="form-contents">
                <h3>Property Details: {{ propertyType }} for {{ listingFor }}</h3>
                <form [formGroup]="thirdAdForm">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6">
                            <label class="form-label">Title <span class="theme-text">*</span></label>
                            <input type="text" formControlName="title" placeholder="Title of your property">
                            <label class="form-label">Total Area (Bigha - Kattha - Dhur - Kanwa) <span class="theme-text">*</span></label>
                            <div class="area-group-row area-input-field">
                                <div class="area-field">
                                    <input type="number" min="0" formControlName="bigha" (input)="updateTotalArea()"
                                        placeholder="0">
                                    <span class="area-label">Bigha</span>
                                </div>
                                <span class="area-separator">-</span>
                                <div class="area-field">
                                    <input type="number" min="0" formControlName="kattha" (input)="updateTotalArea()"
                                        placeholder="0">
                                    <span class="area-label">Kattha</span>
                                </div>
                                <span class="area-separator">-</span>
                                <div class="area-field">
                                    <input type="number" min="0" formControlName="dhur" (input)="updateTotalArea()"
                                        placeholder="0">
                                    <span class="area-label">Dhur</span>
                                </div>
                                <span class="area-separator">-</span>
                                <div class="area-field">
                                    <input type="number" min="0" formControlName="kanwa" (input)="updateTotalArea()"
                                        placeholder="0">
                                    <span class="area-label">Kanwa</span>
                                </div>
                            </div>
                            <label class="form-label">Total Floors</label>
                            <input type="number" formControlName="floor" placeholder="Total floors">
                        </div>
                        <div class="col-12 col-sm-12 col-md-6">
                            <label class="form-label">Price <span class="theme-text">*</span></label>
                            <input type="number" formControlName="price" placeholder="Enter the price of your property">
                            <label class="form-label">House Area (Ropani - Aana - Paisa - Daam)</label>
                            <div class="area-group-row area-input-field">
                                <div class="area-field">
                                    <input type="number" min="0" formControlName="ropani" (input)="updateHouseArea()"
                                        placeholder="0">
                                    <span class="area-label">Ropani</span>
                                </div>
                                <span class="area-separator">-</span>
                                <div class="area-field">
                                    <input type="number" min="0" formControlName="aana" (input)="updateHouseArea()"
                                        placeholder="0">
                                    <span class="area-label">Aana</span>
                                </div>
                                <span class="area-separator">-</span>
                                <div class="area-field">
                                    <input type="number" min="0" formControlName="paisa" (input)="updateHouseArea()"
                                        placeholder="0">
                                    <span class="area-label">Paisa</span>
                                </div>
                                <span class="area-separator">-</span>
                                <div class="area-field">
                                    <input type="number" min="0" formControlName="daam" (input)="updateHouseArea()"
                                        placeholder="0">
                                    <span class="area-label">Daam</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <label class="form-label">Property description</label>
                            <angular-editor class="custom-line-height" formControlName="details"
                                [config]="editorConfig"></angular-editor>
                        </div>
                    </div>
                    <h3>Major Facilities</h3>
                    <div class="row justify-content-between">
                        <div class="col-12 col-sm-12 col-md-6">
                            <div class="row">
                                <div class="col-12 col-sm-12">
                                    Parking
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                    <input type="radio" formControlName="parking" value="Available">&nbsp;<span
                                        class="normal-font">Available</span>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                    <input type="radio" formControlName="parking" value="Not Available">&nbsp;<span
                                        class="normal-font">Not Available</span>
                                </div>
                            </div>
                            <hr class="divider">
                            <div class="row">
                                <div class="col-12 col-sm-12">
                                    Water supply
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                    <input type="radio" formControlName="waterSupply" value="Available">&nbsp;<span
                                        class="normal-font">Available</span>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                    <input type="radio" formControlName="waterSupply" value="Not Available">&nbsp;<span
                                        class="normal-font">Not Available</span>
                                </div>
                            </div>
                            <hr class="divider">
                            <div class="row">
                                <div class="col-12 col-sm-12">
                                    Telecommunication
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                    <input type="radio" formControlName="telecommunication"
                                        value="Available">&nbsp;<span class="normal-font">Available</span>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                    <input type="radio" formControlName="telecommunication"
                                        value="Not Available">&nbsp;<span class="normal-font">Not Available</span>
                                </div>
                            </div>
                            <hr class="divider">
                        </div>
                        <div class="col-12 col-sm-12 col-md-6">
                            <div class="row">
                                <div class="col-12 col-sm-12">
                                    Electricity
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                    <input type="radio" formControlName="electricity" value="Available">&nbsp;<span
                                        class="normal-font">Available</span>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                    <input type="radio" formControlName="electricity" value="Not Available">&nbsp;<span
                                        class="normal-font">Not Available</span>
                                </div>
                            </div>
                            <hr class="divider">
                            <div class="row">
                                <div class="col-12 col-sm-12">
                                    Gas supply
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                    <input type="radio" formControlName="gasSupply" value="Available">&nbsp;<span
                                        class="normal-font">Available</span>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                    <input type="radio" formControlName="gasSupply" value="Not Available">&nbsp;<span
                                        class="normal-font">Not Available</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3>More Facilities</h3>
                    <div class="row relative"
                        *ngFor="let form of otherFacility.get('forms')['controls']; let i = index">
                        <hr *ngIf="i != 0" class="divider">
                        <form [formGroup]="form" class="col-sm-12 row">
                            <div class="col-sm-6">
                                Title<br>
                                <input formControlName="title" type="text"
                                    placeholder="Title of the available facility">
                            </div>
                            <div class="col-sm-6">
                                Details<br>
                                <input formControlName="details" type="text" placeholder="Details about the facility">
                            </div>
                        </form>
                        <button *ngIf="i != 0" class="remove-button" (click)="removeOtherFacilityAt(i)">X</button>
                    </div>
                    <div class="row pt-3">
                        <div class="col-sm-12">
                            <button class="add-more" (click)="addOtherFacility()">+ Add Facility</button>
                        </div>
                    </div>
                    <div class="row pt-5 justify-content-between px-3">
                        <button (click)="previous()">← &nbsp;&nbsp;&nbsp; Previous Step</button>
                        <button [disabled]="thirdAdForm.invalid" (click)="next()">Next Step &nbsp;&nbsp;&nbsp;→</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>